module.exports = __webpack_public_path__ + "img/thyssenkrupp.af16666e.svg";